import { cn, useIsMobile } from '@heidi/utils';
import { DictationBubbleShell } from '../../../shared/components/dictation-bubble-shell';
import { DictationProcessingContent } from '../../../shared/components/dictation-processing-content';
import { DICTATION_BUBBLE_Z_INDEX_CLASS } from '../../../shared/styles';
import { useDictationStore } from '../../store/useDictationStore';
import { bubbleExitAnimation } from '../consts/animation';

export const DictationProcessing = () => {
  const cancel = useDictationStore((s) => s.cancel);
  const isMobile = useIsMobile();

  return (
    <DictationBubbleShell
      animation={bubbleExitAnimation}
      className={cn(
        'fixed inset-x-0 mx-auto flex w-fit flex-col items-center gap-2',
        DICTATION_BUBBLE_Z_INDEX_CLASS,
        isMobile ? 'bottom-32' : 'bottom-6'
      )}
    >
      <DictationProcessingContent onCancel={cancel} />
    </DictationBubbleShell>
  );
};
